import React from 'react';
import { Box, Skeleton, Card, CardContent, Paper, Grid } from '@mui/material';

const LoadingSkeleton = ({ type = 'cards', count = 4 }) => {
  const renderCardSkeleton = () => (
    <Card sx={{ borderRadius: 4, overflow: 'hidden' }}>
      <Skeleton variant="rectangular" height={200} />
      <CardContent>
        <Skeleton variant="text" height={32} width="60%" />
        <Skeleton variant="text" height={24} width="40%" />
        <Skeleton variant="text" height={20} width="80%" />
      </CardContent>
    </Card>
  );

  const renderEarningsSkeleton = () => (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 4,
        background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        animation: 'pulse 2s ease-in-out infinite',
      }}
    >
      <Skeleton variant="circular" width={40} height={40} sx={{ mx: 'auto', mb: 2 }} />
      <Skeleton variant="text" height={24} width="70%" sx={{ mx: 'auto', mb: 1 }} />
      <Skeleton variant="text" height={36} width="50%" sx={{ mx: 'auto' }} />
    </Paper>
  );

  const renderTableSkeleton = () => (
    <Card sx={{ borderRadius: 4, overflow: 'hidden' }}>
      <CardContent>
        <Skeleton variant="text" height={40} width="100%" sx={{ mb: 2 }} />
        {[...Array(5)].map((_, index) => (
          <Box key={index} sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <Skeleton variant="circular" width={40} height={40} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" height={20} width="60%" />
              <Skeleton variant="text" height={16} width="40%" />
            </Box>
            <Skeleton variant="rectangular" width={80} height={32} />
          </Box>
        ))}
      </CardContent>
    </Card>
  );

  const renderListSkeleton = () => (
    <Box>
      {[...Array(count)].map((_, index) => (
        <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="circular" width={48} height={48} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" height={24} width="70%" />
              <Skeleton variant="text" height={16} width="50%" />
            </Box>
            <Skeleton variant="rectangular" width={100} height={36} />
          </Box>
        </Box>
      ))}
    </Box>
  );

  const renderContent = () => {
    switch (type) {
      case 'earnings':
        return (
          <Grid container spacing={3}>
            {[...Array(count)].map((_, index) => (
              <Grid xs={12} sm={6} md={3} key={index}>
                {renderEarningsSkeleton()}
              </Grid>
            ))}
          </Grid>
        );
      case 'table':
        return renderTableSkeleton();
      case 'list':
        return renderListSkeleton();
      case 'cards':
      default:
        return (
          <Grid container spacing={3}>
            {[...Array(count)].map((_, index) => (
              <Grid xs={12} sm={6} md={4} key={index}>
                {renderCardSkeleton()}
              </Grid>
            ))}
          </Grid>
        );
    }
  };

  return (
    <Box>
      {renderContent()}
    </Box>
  );
};

export default LoadingSkeleton;
